exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-inschrijvingen-js": () => import("./../../../src/pages/inschrijvingen.js" /* webpackChunkName: "component---src-pages-inschrijvingen-js" */),
  "component---src-pages-vrijwilliger-js": () => import("./../../../src/pages/vrijwilliger.js" /* webpackChunkName: "component---src-pages-vrijwilliger-js" */)
}

